import { SpeedUnits } from "convert-units";
import { formatUnitValue } from "../../lib/convert";
import { LabeledValue } from "../base/LabeledValue";

import { Gamepad2, Joystick } from "lucide-react";
import Tooltip from "../base/Tooltip";
type CameraSpeedProps = {
  value?: number;
  showLabels?: boolean;
  precision?: number;
  units?: SpeedUnits;
  gamepadSelected?: number;
  gamepadSpeedSensitivity?: number;
};

const CameraSpeedDisplay = ({
  value,
  showLabels = true,
  units,
  precision,
  gamepadSelected,
  gamepadSpeedSensitivity,
}: CameraSpeedProps) => {
  let to = units;
  if (!to && value != undefined) {
    to = value >= 0.28 ? "km/h" : "m/s";
  }
  precision ??= to === "m/s" ? 1 : 3;
  gamepadSelected ??= -1;
  return (
    <div className="flex items-center space-x-2">
      <LabeledValue
        label={showLabels && "Speed"}
        value={
          formatUnitValue(value, {
            from: "m/s",
            to,
            precision,
            showUnits: true,
          }) ?? "-"
        }
      />
      {(gamepadSelected >= 0) && (
        <>
          <div className="inline-flex items-center space-x-1 mx-2">
            <Tooltip content="Gamepad connected">
              <Gamepad2 size={12} />
            </Tooltip>
          </div>
          {gamepadSpeedSensitivity && (
            <Tooltip content="Gamepad speed sensitivity">
              <div className="flex items-center space-x-1">
                <div className="inline-flex items-center space-x-1">
                  <Joystick size={12} />
                </div>
                <LabeledValue
                  value={gamepadSpeedSensitivity}
                  minWidth={"0em"}
                />
              </div>
            </Tooltip>
          )}
        </>
      )}
    </div>
  );
};

export default CameraSpeedDisplay;
